var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermsChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66777 10.5378C7.854 10.7088 8.15497 10.7088 8.3412 10.5378L13.1963 6.07911C13.3825 5.90815 13.3825 5.63186 13.1963 5.4609C13.01 5.28994 12.7091 5.28994 12.5228 5.4609L8.0026 9.61049L3.48237 5.4609C3.39019 5.37628 3.26792 5.33311 3.14565 5.33311C3.02338 5.33311 2.90299 5.37628 2.80894 5.4609C2.62271 5.63186 2.62271 5.90815 2.80894 6.07911L7.66589 10.5378L7.66777 10.5378Z",
    fill: "#CCD0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsChevron);
export default __webpack_public_path__ + "static/media/termsChevron.21c0ffdfeba80a1660ac2d1a67d9df0b.svg";
export { ForwardRef as ReactComponent };